// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settings-page {
  max-width: 760px;
  padding-top: 28px;
  padding-bottom: 40px;
}

.settings-page h1 {
  margin-bottom: 18px;
  color: #0f172a;
  font-size: 27px;
}

.settings-page-card {
  border-color: #dbe3e8;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.07);
}

.settings-page-card h2 {
  margin: 0 0 20px;
  color: #0f172a;
  font-size: 19px;
}

.settings-page-language {
  margin: 0 0 22px;
  padding: 0;
  border: 0;
}

.settings-page-language legend {
  margin-bottom: 9px;
  color: #334155;
  font-size: 14px;
  font-weight: 650;
}

.settings-page-language-options {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.settings-page-language-option {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  min-width: 175px;
  padding: 10px 14px;
  border: 1px solid #cbd5e1;
  border-radius: 10px;
  background: #fff;
  color: #0f172a;
  cursor: pointer;
  font-weight: 600;
}

.settings-page-language-option:has(input:checked) {
  border-color: #15803d;
  background: #f0fdf4;
  box-shadow: 0 0 0 1px #15803d inset;
}

.settings-page-language-option:focus-within {
  outline: 2px solid #2563eb;
  outline-offset: 2px;
}

.settings-page-language-option input,
.settings-page-developer-option input {
  margin: 0;
  accent-color: #15803d;
}

.settings-page-language-option img {
  display: block;
  width: auto;
  height: 30px;
  flex: none;
}

.settings-page-developer-option {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #0f172a;
  cursor: pointer;
}

.settings-page-developer-option input {
  appearance: none;
  position: relative;
  width: 42px;
  height: 24px;
  border: 1px solid #94a3b8;
  border-radius: 999px;
  background: #cbd5e1;
  cursor: pointer;
  flex: none;
  transition: background 150ms ease;
}

.settings-page-developer-option input::before {
  content: "";
  position: absolute;
  top: 2px;
  left: 2px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.2);
  transition: transform 150ms ease;
}

.settings-page-developer-option input:checked {
  border-color: #15803d;
  background: #15803d;
}

.settings-page-developer-option input:checked::before {
  transform: translateX(18px);
}

.settings-page-developer-option input:focus-visible {
  outline: 2px solid #2563eb;
  outline-offset: 2px;
}

.settings-page-developer-options {
  display: grid;
  gap: 8px;
  margin: 14px 0 0 20px;
  padding-left: 20px;
  border-left: 2px solid #dbe3e8;
}

.settings-page-developer-detail {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 8px 0;
  color: #0f172a;
  cursor: pointer;
}

.settings-page-developer-detail:has(input:disabled) {
  color: #64748b;
  cursor: default;
}

.settings-page-developer-detail input {
  margin-top: 4px;
  accent-color: #15803d;
}

.settings-page-developer-detail span {
  display: grid;
  gap: 2px;
}

.settings-page-developer-detail small {
  color: #64748b;
  line-height: 1.35;
}

.settings-page-note {
  margin: 18px 0 0;
  color: #64748b;
  font-size: 13px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/personal/settings_page.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;;EAEE,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,UAAU;EACV,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,2CAA2C;EAC3C,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,qBAAqB;EACrB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB","sourcesContent":[".settings-page {\n  max-width: 760px;\n  padding-top: 28px;\n  padding-bottom: 40px;\n}\n\n.settings-page h1 {\n  margin-bottom: 18px;\n  color: #0f172a;\n  font-size: 27px;\n}\n\n.settings-page-card {\n  border-color: #dbe3e8;\n  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.07);\n}\n\n.settings-page-card h2 {\n  margin: 0 0 20px;\n  color: #0f172a;\n  font-size: 19px;\n}\n\n.settings-page-language {\n  margin: 0 0 22px;\n  padding: 0;\n  border: 0;\n}\n\n.settings-page-language legend {\n  margin-bottom: 9px;\n  color: #334155;\n  font-size: 14px;\n  font-weight: 650;\n}\n\n.settings-page-language-options {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\n.settings-page-language-option {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 175px;\n  padding: 10px 14px;\n  border: 1px solid #cbd5e1;\n  border-radius: 10px;\n  background: #fff;\n  color: #0f172a;\n  cursor: pointer;\n  font-weight: 600;\n}\n\n.settings-page-language-option:has(input:checked) {\n  border-color: #15803d;\n  background: #f0fdf4;\n  box-shadow: 0 0 0 1px #15803d inset;\n}\n\n.settings-page-language-option:focus-within {\n  outline: 2px solid #2563eb;\n  outline-offset: 2px;\n}\n\n.settings-page-language-option input,\n.settings-page-developer-option input {\n  margin: 0;\n  accent-color: #15803d;\n}\n\n.settings-page-language-option img {\n  display: block;\n  width: auto;\n  height: 30px;\n  flex: none;\n}\n\n.settings-page-developer-option {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  color: #0f172a;\n  cursor: pointer;\n}\n\n.settings-page-developer-option input {\n  appearance: none;\n  position: relative;\n  width: 42px;\n  height: 24px;\n  border: 1px solid #94a3b8;\n  border-radius: 999px;\n  background: #cbd5e1;\n  cursor: pointer;\n  flex: none;\n  transition: background 150ms ease;\n}\n\n.settings-page-developer-option input::before {\n  content: \"\";\n  position: absolute;\n  top: 2px;\n  left: 2px;\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  background: #fff;\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.2);\n  transition: transform 150ms ease;\n}\n\n.settings-page-developer-option input:checked {\n  border-color: #15803d;\n  background: #15803d;\n}\n\n.settings-page-developer-option input:checked::before {\n  transform: translateX(18px);\n}\n\n.settings-page-developer-option input:focus-visible {\n  outline: 2px solid #2563eb;\n  outline-offset: 2px;\n}\n\n.settings-page-developer-options {\n  display: grid;\n  gap: 8px;\n  margin: 14px 0 0 20px;\n  padding-left: 20px;\n  border-left: 2px solid #dbe3e8;\n}\n\n.settings-page-developer-detail {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 8px 0;\n  color: #0f172a;\n  cursor: pointer;\n}\n\n.settings-page-developer-detail:has(input:disabled) {\n  color: #64748b;\n  cursor: default;\n}\n\n.settings-page-developer-detail input {\n  margin-top: 4px;\n  accent-color: #15803d;\n}\n\n.settings-page-developer-detail span {\n  display: grid;\n  gap: 2px;\n}\n\n.settings-page-developer-detail small {\n  color: #64748b;\n  line-height: 1.35;\n}\n\n.settings-page-note {\n  margin: 18px 0 0;\n  color: #64748b;\n  font-size: 13px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
